<template>
  <div class="app-container">
    <CrudTable entity="Unit" :columns="columns" :generate-summary="generateSummary" />
  </div>
</template>

<script>
import CrudTable from '@/components/crud/CrudTable';
export default {
  components: {
    CrudTable
  },
  data() {
    return {
      columns: ['description']
    };
  },
  methods: {
    generateSummary({ description }) {
      const summary = `${description}`;
      return summary;
    }
  }
};
</script>
